
// bao migrate skip commit 3ab3f81d
import * as $ from "jquery";
if (!String.prototype.trim) {
    String.prototype.trim = function () { return this.replace(/^\s+|\s+$/g, ''); };
    String.prototype.ltrim = function () { return this.replace(/^\s+/, ''); };
    String.prototype.rtrim = function () { return this.replace(/\s+$/, ''); };
    String.prototype.fulltrim = function () { return this.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' '); };
    //code for trim
}
if (typeof String.prototype.startsWith != 'function') {
    // see below for better implementation!
    String.prototype.startsWith = function (str) {
        return this.indexOf(str) == 0;
    };
}
String.prototype["endsWith"] = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
export class Utils {

    public String: StringUtils = new StringUtils();
    public DateFormat = "YYYYMMDDHHmmss";
    public DateOnlyFormat = "YYYYMMDD";
    public DateDisplayFormat = "L";
    public DateTimeFormat = "YYYYMMDDHHmmss";
    public DateTimeDisplayFormat = "L LT";
    public stopPropagation(evt: Event) {
        if (typeof evt.stopPropagation != "undefined") {
            evt.stopPropagation();
        }
        else {
            evt.cancelBubble = true;
        }
    }

    public PreventBackspace() {
        $(document).unbind('keydown').bind('keydown', function (event) {
            var doPrevent = false;
            if (event.keyCode === 8) {
                let d: any = event["srcElement"] || event.target;
                if ((d.tagName.toUpperCase() === 'INPUT' && (d["type"].toUpperCase() === 'TEXT' || d["type"].toUpperCase() === 'PASSWORD'))
                    || d.tagName.toUpperCase() === 'TEXTAREA' || d["contentEditable"]) {
                    doPrevent = d["readOnly"] || d["disabled"];
                }
                else {
                    doPrevent = true;
                }
            }
            if (doPrevent) {
                event.preventDefault();
            }
        });
    }

    public scrollPosition() {
        if (typeof pageYOffset != 'undefined') {
            //most browsers except IE before #9
            return pageYOffset;
        }
        else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
        }
    }

    public ObjectToHashObjectArray(obj: object | Array<any>): Array<Models.HashObject> {
        let res: Array<Models.HashObject> = [];
        for (let i in obj) {
            res.push({ Key: i, Value: obj[i] });
        }
        return res;
    }
    /**
     * Method is used to read the param 
     * @param paramName
     */
    public ReadParam(paramName): Models.HashObject {
        const url = new URL(window.location.href);
        let param: Models.HashObject = { Key: "", Value: "" };

        url.searchParams.forEach((value, key) => {
            if (key.toLowerCase() === paramName) {
                param.Value = value;
                param.Key = key;
            }
        });
        return param;
    }
    /**
     * Method is used to remove the param
     * @param paramName
     */
    public RemoveParam(paramName) {
        const url = new URL(window.location.href);
        let param = this.ReadParam(paramName);

        url.searchParams.delete(param?.Key);
        history.replaceState(null, null, url.href);

    }

}
export class StringUtils {
    IsNullOrEmpty(s: string): boolean {
        if (s == null || s == "") {
            return true;
        }
        return false;
    }
    ;
    IsNullOrWhitespace(s: string): boolean {
        if (s == null || s.trim() == "") {
            return true;
        }
        return false;
    }
    ;
}
export default new Utils();